/**
 * 港股双柜台
 */
import { Observer } from "mobx-react-lite"
import React, { useEffect, useState } from "react"
import hk_rule from "../../../modules/hk_rule"
import { getStockDetailData } from "../../../modules/quote/web"
import { PageType, StockCurrency } from "../../shared/pagetype"
import { single_quote, quote_item_name } from "../../shared/quotedata/index"
import { store } from "./store"

export function DoubleCounter(props: { pagetype: PageType }) {
  const [dcData, setDCData] = useState()

  const getDoubleCounterData = async (quotecode: string) => {
    let data = await getStockDetailData(quotecode, "f43,f57,f58,f59,f60,f152,f169,f170,f172")
    if (data) {
      setDCData(data)
    }
  }

  const clickDC = (data: any) => {
    window.location.href = `/quote/stock/${data.f752}.${data.f751}.html`
  }


  useEffect(() => {
    if (store.StockDetail.f751 && store.StockDetail.f752) {
      let quotecode_new = `${store.StockDetail.f752}.${store.StockDetail.f751}`
      getDoubleCounterData(quotecode_new)
      //港股不登陆或者海外 不刷新
      let timer:any = null
      timer && clearInterval(timer)
      hk_rule.isDelayCache().then((back: any) => {
        if (!back.re) {
          timer = setInterval(() => {
            getDoubleCounterData(quotecode_new)
          }, 30 * 1000)
        }
      })
      return () => {
        timer && clearInterval(timer)
      }
    }
  }, [])

  return (
    <Observer>
      {() => (
        <>
          {store.StockDetail.f751 != "-" && dcData && props.pagetype == PageType.港股 && (
            <div className="ah-notice">
              <div className="ah-container" onClick={() => clickDC(store.StockDetail)}>
                <p>
                  {store.StockCurrency == StockCurrency.人民币 && <span>相关港股（港元计价）：</span>}
                  {store.StockCurrency == StockCurrency.港元 && <span>相关港股（人民币计价）：</span>}
                  {single_quote[quote_item_name.港股双柜台最新价](dcData).element}
                  &nbsp;&nbsp;&nbsp;
                  {single_quote[quote_item_name.港股双柜台涨跌幅](dcData).element}
                </p>
                <p className="bottom-extra-right">
                  <a>
                    <i className="arrow-right-new"></i>
                  </a>
                </p>
              </div>
            </div>
          )}
        </>
      )}
    </Observer>
  )
}
